import React, {useState} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import RoleRibbonByRole from '../../../organisms/common/role-ribbon/role-ribbon-by-role';
import { getAuthToken, getCurrentRole } from '../../../../utils/auth';
import { canAccessClientPreview } from '../../../../utils/role-utils';
import Wadsworth from '../../../organisms/role-hac/wadsworth/wadsworth';
import Footer from "../../../organisms/footer/footer";
import ModalHacShowContact from "../../../organisms/role-hac/modal-hac-show-contact/modal-hac-show-contact";

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Product from "../../../organisms/common/products/product";
import {useTranslation} from "react-i18next";

const HacProduct = () => {

  window.scroll(0, 0);

  const token = getAuthToken();
  const role = getCurrentRole(token);
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      {token && (role === 'hac' || role === 'retailer' || role === 'retailerGM' || role === 'pma' || canAccessClientPreview(role)) ? (
        <div className="App">
          <Header/>
          <main className="product">
            {role === 'hac' && (
              <Wadsworth/>
            )}
            <RoleRibbonByRole role={role} navigate={navigate} translate={t} context="clientView" />
            <Product></Product>
          </main>
          <ModalHacShowContact
            open={openModal}
            handleClose={handleCloseModal}
            className="modal-contact"
          />
          <Footer/>
        </div>
      ) : (
        <Navigate to="/login"/>
      )}
    </>
  );
};

export default HacProduct;
